import { Box, Switch, Typography } from "@mui/material";
import { stripHTMLTags } from "../utilities/common";

type SwitchWithTitleProps = {
  title: string;
  description?: string;
  selected: boolean;
  onSelect: () => void;
  orientation?: "space_between" | "left";
  bold?: boolean;
  disabled?: boolean;
};

export const SwitchWithTitle = (props: SwitchWithTitleProps) => {
  const {
    title,
    description,
    selected,
    onSelect,
    orientation = "left_aligned",
    bold = true,
    disabled = false,
  } = props;
  const textVariant = bold ? "h3" : "body2";
  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
    >
      {orientation === "left_aligned" && (
        <Box display="flex" alignItems="center">
          <Switch
            checked={selected}
            disabled={disabled}
            onChange={(_, checked) => !disabled && onSelect()}
            edge="start"
          />
          <Typography variant={textVariant}>{title}</Typography>
        </Box>
      )}
      {orientation === "space_between" && (
        <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
          <Typography variant={textVariant}>{title}</Typography>
          <Switch
            checked={selected}
            disabled={disabled}
            onChange={(_, checked) => !disabled && onSelect()}
            edge="end"
          />
        </Box>
      )}
      {description && <Typography variant="small">{stripHTMLTags(description)}</Typography>}
    </Box>
  );
};
